export default "__VITE_PUBLIC_ASSET__05c53b4d__"